import Todo from "./component/Todo";

function App() {
  return (
    <div className="App">
      <header>
        <h1>그저 Todo List 📋</h1>
      </header>
      <Todo></Todo>
    </div>
  );
}

export default App;
